import { Pressable } from 'react-native';

import { Badge } from '@/components/ui/Badge';
import { cn } from '@/components/ui/cn';
import { Text } from '@/components/ui/Text';

export interface PaywallPlan {
  id: string;
  title: string;
  price: string;
  sub: string;
  badge?: string;
}

export function PlanOptionCard({
  plan,
  selected,
  onPress,
}: {
  plan: PaywallPlan;
  selected: boolean;
  onPress: () => void;
}) {
  return (
    <Pressable
      onPress={onPress}
      className={cn(
        'flex-1 gap-1 rounded-2xl border-[1.5px] bg-card p-4',
        selected ? 'border-signal' : 'border-border',
      )}
    >
      {plan.badge ? <Badge label={plan.badge} tone="signal" /> : null}
      <Text variant="bodySemibold">{plan.title}</Text>
      <Text variant="title" className="text-2xl">
        {plan.price}
      </Text>
      <Text variant="caption">{plan.sub}</Text>
    </Pressable>
  );
}
